/**
 * Is a Google Tag Manager container already on the page?
 *
 * react-snap prerenders each public route by running the app in a browser and
 * snapshotting the DOM — which includes the <script> tags TagManager.initialize
 * injected. The browser then loads those on the next visit, hydration runs
 * index.js again, and the same container is injected a second time.
 *
 * Each container was therefore loading twice on every prerendered page, and
 * GA4 lives inside one of them: every pageview was counted twice, and all the
 * historical traffic numbers are inflated (Trello MzcRAvqf). Non-prerendered
 * routes have no baked tag, so this must be a presence check rather than a
 * blanket "never initialize".
 *
 * @param {string} gtmId
 * @param {Document | null} [doc]
 */
export const tagManagerLoaded = (
  gtmId,
  doc = typeof document === "undefined" ? null : document
) => {
  if (!doc || typeof gtmId !== "string" || !gtmId) return false;
  return Array.from(doc.querySelectorAll("script[src]")).some((script) => {
    const src = script.getAttribute("src") || "";
    return src.includes("googletagmanager.com/gtm.js") && src.includes(`id=${gtmId}`);
  });
};

export default tagManagerLoaded;
